import * as React from "react";
import {BaseFormViewState, default as BaseFormView} from "../../../../ui/form/BaseFormView";
import TaskForm from "../TaskForm";
import FormButtonsView from "../../../../ui/form/FormButtonsView";
import TaskFormBody from "../TaskFormBody";
import ButtonPrimary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import Task from "../../../../../model/task/Task";

interface IComponentProps {
	/**
	 * On submit callback. Should call only when form is valid.
	 * @param {Task} data
	 */
	onSubmit: (data: Task) => void;
	/**
	 * On cancel button handler.
	 */
	onCancel: () => void;
	/**
	 * Indicate if any server action is in progress.
	 */
	isSubmitting: boolean;
}

type IState = BaseFormViewState<TaskForm>;

export default class CreateTaskFormView extends BaseFormView<TaskForm, IComponentProps, IState> {
	constructor(props: IComponentProps) {
		super(props);
		this.state = {
			form: TaskForm.createEmpty(),
			isFormDirty: false,
			shouldValidate: false
		};
	}

	render() {
		return (
			<div>
				<TaskFormBody form={this.state.form}
							  onFieldChange={this.onFieldChanged}
							  onFieldCompleted={this.onFieldCompleted}
							  onFocusChange={this.onFocusChange}
							  onFieldsChange={this.onFieldsChanged}/>
				<FormButtonsView align={"right"}>
					<ButtonTertiary onClick={this.props.onCancel}
									label={"Cancel"}
									disabled={this.props.isSubmitting}/>
					<ButtonPrimary onClick={() => this.submitForm()}
								   label={"Create task"}
								   disabled={this.props.isSubmitting}
								   isLoading={this.props.isSubmitting}/>
				</FormButtonsView>
			</div>
		);
	}

	submitForm(): void {
		this.setState({shouldValidate: true, form: this.state.form.validate()}, () => {
			this.state.form.onValid(this.props.onSubmit);
		});
	}
}